<div class="call-recording">
  <div class="vox-inline-message vox-inline-message_light-grey mb-3">
    <div>
      <i class="icon-small-info"></i>
      <span>
        {{ "events.company-call-history.details.call-recording.disclaimer" | Translate }}
      </span>
    </div>
  </div>
  <div class="call-recording__audio-player">
    <vox-audio-player [fileUrl]="callItem.recordingUrl"></vox-audio-player>
    <button
      class="btn btn-primary_royal-blue"
      (click)="openLink(callItem.recordingUrl)">
      <i class="icon-small-download-audio"></i>
    </button>
  </div>
</div>
